import React from 'react';
import classNames from 'classnames';
import XMarkIcon from '~/components/atoms/icon/xMark/XMarkIcon';
import { CloseSERP } from '~/hooks/useShowSearch';
import styles from './closeButton.module.scss';

interface ICloseProps extends React.PropsWithChildren, React.HTMLAttributes<HTMLButtonElement> {
    closeSERP: CloseSERP;
}

const CloseButton: React.FC<ICloseProps> = ({ closeSERP, children, ...props }) => {
    return (
        <div id="serp-close-button" className={styles.closeWrapper} data-testid="close-wrapper">
            <button
                onClick={() => {
                    closeSERP();
                }}
                className={classNames(styles.closeButton)}
                {...props}
            >
                <XMarkIcon width={34} height={34} data-testid="close-button-icon" />
                <span className={styles.closeText}>{children}</span>
            </button>
        </div>
    );
};

export default CloseButton;
